export default "__VITE_PUBLIC_ASSET__2b6ae5bc__"